class ChartHelper {
	static ProcessPieChart(config) {
		if(config.type === "pie" && config.data.datasets.length === 1) {
			const dataset = config.data.datasets[0];
			if(dataset.data.length === 0) {
				config.data.labels = [__("No Data")];
				config.data.datasets[0] = {
					data: [1],
					backgroundColor: ["#eeeeee"]
				};
				config.options.legend = {
					onClick: null
				};
				config.options.tooltips = {
					enabled: false
				};
			}
		}

		return config;
	}

	static ProcessChartConfigInputElement(element) {
		const $input = $(element);
		let config = JSON.parse($input.val());
		const { target } = $input.data();

		if($input.attr("data-rendered") === "true") {
			return;
		}

		config = ChartHelper.ProcessPieChart(config);

		if(config.showDataLabels) {
			config = ChartHelper.EnableDataLabels(config, config.dataLabelsPercentage);
		}

		new Chart($(target).get(0), config);

		$input.attr("data-rendered", "true");
	}

	static EnableDataLabels(config, percentages = false) {
		config.plugins = [ChartDataLabels];

		const pluginOptions = {
			backgroundColor: context => {
				if(context.dataset.borderColor) {
					return context.dataset.borderColor;
				}

				return context.dataset.backgroundColor;
			},
			borderRadius: 4,
			color: "white",
			font: {
				weight: "bold"
			},
			padding: 2,
			display: context => {
				return context.dataset.data[context.dataIndex] > 0;
			}
		};

		if(percentages) {
			pluginOptions.formatter = (value, ctx) => {
				let sum = 0;
				const dataArr = ctx.chart.data.datasets[0].data;
				dataArr.map(data => sum += data);
				return (value * 100 / sum).toFixed(2) + "%";
			};
		}

		config.options.plugins = {
			datalabels: pluginOptions
		};

		return config;
	}
}
